import { useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import { getStatusTranslation } from "../utils/getStatusTranslation";
export var usePublisherPrefixRangeTable = function (onRowClick) {
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var handleAgencyPrefixClick = useCallback(function (item) {
        onRowClick(item);
    }, [onRowClick]);
    var getAgencyPrefixCellRenderer = useCallback(function (item) {
        return item.agencyPrefix
            ? "".concat(item.agencyPrefix.internationalPrefix.agency, " ").concat(item.agencyPrefix.internationalPrefix.value, "-").concat(item.agencyPrefix.value)
            : "";
    }, []);
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.agency.prefix",
            }),
            key: "agencyPrefix",
            cellRenderer: function (item) { return getAgencyPrefixCellRenderer(item); },
            clickable: true,
            onClick: handleAgencyPrefixClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.column.magnitude",
            }),
            key: "magnitude",
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.column.start",
            }),
            key: "start",
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.column.end",
            }),
            key: "end",
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.column.status",
            }),
            key: "status",
            width: "90px",
            cellRenderer: function (item) { return getStatusTranslation(intl, item.status); },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.column.nextSequence",
            }),
            key: "nextSequence",
        },
    ]; }, [formatMessage, handleAgencyPrefixClick, getAgencyPrefixCellRenderer, intl]);
    return {
        columns: columns,
    };
};
